module.exports = "/images/bm.svg?32eb4bc06b9d4720b8999cf17ac36ac9";